module.exports = __webpack_public_path__ + "img/group-payment.31a54a33.svg";